import React, { useEffect, useState } from "react";
import { IChartOption } from "src/shared/models/IDashboards.models";
import ReactECharts from 'echarts-for-react';
import { NoDataChart } from "./NoDataChart";
import { fCurrency } from "src/helpers/generalFunctions";

interface FormProps {
  details: IChartOption;
  titleChart: string;
  mixColors?: boolean; 
  titleChartNoData: string;
  typeIcon?: boolean;
}

export const EchartBasicBar = React.memo(({ details, titleChart, mixColors = false, titleChartNoData, typeIcon = false }: FormProps) => {
  const chartColors = ["#B0E57C", "#00C1B5", "#FFB74D", '#2196F3', '#79C4FF', "#B0E57C", "#00C1B5", "#FFB74D", '#2196F3', '#79C4FF',"#B0E57C", "#00C1B5", "#FFB74D", '#2196F3', '#79C4FF']; 
  const [option, setOption] = useState<any>(null);

  useEffect(() => {
    if(details?.labels?.length > 0)
      loadData()
  }, [details]);

  const loadData = () => {
    const dataInfo = 
      details?.labels?.map((y: any, index: number) => {
        return { 
          value: details?.series[index] ?? 0, name: y,  
          itemStyle: {
            color: mixColors ? chartColors[index % chartColors.length] :  chartColors[0]// Asigna un color diferente a cada punto de datos
          }};
      }) || {}
    setOption(
    {
      title : {
        text: titleChart,
        subtext: "",//'subtitulo'
        x:'left',
        y: 25,
        textStyle: {
          fontSize: 16,
          fontFamily: 'Open Sans,sans-serif',
        },
      },
      grid: {
        top: 70, // Ajusta este valor para agregar margen debajo del título
        // bottom: 40 // Ajusta este valor para agregar margen en la parte inferior
      },
      tooltip : {
        trigger: 'item',
        formatter: (params: any) => `${params.name} : ${fCurrency(params.value)}`
        // formatter: (params: any) => `${params.name} : ${formatCurrency(params.value)}`
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontFamily: 'Open Sans,sans-serif',
          fontSize: 9, // Ajusta el tamaño de la fuente aquí
          overflow: 'break', // Trunca el texto que se pasa del límite
          width: 40, // Ajusta el ancho máximo del label
          formatter: (value: number) => fCurrency(value)
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        },
        
      },
      xAxis: {
        type: 'category' ,
        data:  details?.labels ?? [],
        axisLabel: {
          overflow: 'break', // Trunca el texto que se pasa del límite
          width: 40, // Ajusta el ancho máximo del label
        },
      },
      series : [
        mixColors ? {
          name: titleChart,
          colorBy: 'data',
          type: "bar",
          data: dataInfo,
          color: chartColors,
          fontFamily: 'Open Sans,sans-serif',
          itemStyle: {
            fontFamily: 'Open Sans,sans-serif',
            emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            }
          },
        } : {
          name: titleChart,
          type: "bar",
          data: dataInfo,
          fontFamily: 'Open Sans,sans-serif',
          itemStyle: {
            fontFamily: 'Open Sans,sans-serif',
            emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            }
          },
        } 
      ]
    })
  }

  if (!option && details?.labels?.length > 0) return <></>;

  return (
    <>
    {
      details?.labels?.length > 0 ? 
      <ReactECharts
        option={option}
        style={{ height: 200 }}
        // style={{ height: 300 }}
        onEvents={{
          // 'click': onChartClick,
          // 'legendselectchanged': onChartLegendselectchanged
        }}
        />
      : <NoDataChart titleChart={titleChart} titleChartNoData={titleChartNoData} typeIcon={typeIcon} />
    }
    </>
  );
});